import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import React, { useEffect, useState } from 'react';
import { constants } from '../../constants';
import useMyMApi from '../../hooks/useMyMApi';
import useWebContext from '../../hooks/useWebContext';
import { MyMButton, MyMCloseButton } from '../../ui-elements/MyMButton';
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import NewsRegistrationGlobal from '../MyM504_NewsRegistrationGlobal/NewsRegistrationGlobal';
import NewsRegistrationInternal from '../MyM505_NewsRegistrationInternal/NewsRegistrationInternal';
import NewsManagementList from './NewsManagementList';

/**
 * NewsManagement Page Component
 */
const NewsManagement = () => {

  const screenId = 'MyM503';
  const apiRequest = useMyMApi(screenId);
  const { controlSettings, screenSettings } = useWebContext(screenId);
  // モーダル表示情報
  const [modalInfo, setModalInfo] = useState({ isOpen: false, newsType: null, newsId: null });
  // 初期Newsページ
  const [newsManagedPage, setNewsManagedPage] = useState(null);
  // ページ再表示要否
  const [needsRefreshPage, setNeedsRefreshPage] = useState(false);

  // 初期表示
  useEffect(() => {
    const callbackRequestNewsManagementLoad = (result) => {
      setNewsManagedPage(result);
    }
    apiRequest.requestJson(`api/news/management-load?LimitMaxRowCount=${screenSettings.MaxRowCount}`, 'GET', callbackRequestNewsManagementLoad)
  }, []);

  if (newsManagedPage === null)
    return <MyMProgress />

  return (
    <Container className='d-flex justify-content-center mt-4 flex-column'>
      {/* NewsList */}
      <NewsManagementList
        screenId={screenId}
        initNewsManagedPage={newsManagedPage}
        setModalInfo={setModalInfo}
        needsRefreshPage={needsRefreshPage}
        setNeedsRefresh={setNeedsRefreshPage} />
      {/* ボタン群 */}
      <Stack direction='row' spacing={3} className='my-2'>
        <MyMButton onClick={() => { setModalInfo({ ...modalInfo, isOpen: true, newsType: constants.NewsType.GlobalNews, newsId: null }) }}>{controlSettings.LabelList.btnAddGlobal}</MyMButton>
        {/* 2024.5.8 MyMine Version1.5対応 Add Start */}
        <MyMButton onClick={() => { setModalInfo({ ...modalInfo, isOpen: true, newsType: constants.NewsType.InternalNews, newsId: null }) }}>{controlSettings.LabelList.btnAddInternal}</MyMButton>
        {/* 2024.5.8 MyMine Version1.5対応 Add End */}
        <MyMCloseButton className='ms-auto' closeText={controlSettings.LabelList.btnClose}></MyMCloseButton>
      </Stack>
      {/* モーダル */}
      <MyMModal
        open={modalInfo.isOpen}
        onClose={
          // 2024.5.8 MyMine Version1.5対応 Add Start
          (e, r) => {
            // InternalNewsの場合、背景をクリックしてもモーダルが閉じないようにに制御
            if (modalInfo.newsType === constants.NewsType.InternalNews && r === 'backdropClick') return;
            // 2024.5.8 MyMine Version1.5対応 Add End
            setModalInfo({ ...modalInfo, isOpen: false })
          }
        }
        // 2024.5.8 MyMine Version1.5対応 Modify Start
        // 2024.9.16 MyMine Version2.0対応 Modify Start
        width='70%'
        // 2024.9.16 MyMine Version2.0対応 Modify End
        height={modalInfo.newsType === constants.NewsType.GlobalNews ? '91%' : '95%'}
        // 2024.5.8 MyMine Version1.5対応 Modify End
      >
        {modalInfo.newsType === constants.NewsType.GlobalNews && <NewsRegistrationGlobal newsId={modalInfo.newsId} callerRefresh={() => { setNeedsRefreshPage(true) }} handleModalClose={() => setModalInfo({ ...modalInfo, isOpen: false })} />}
        {/* 2024.5.8 MyMine Version1.5対応 Add Start */}
        {modalInfo.newsType === constants.NewsType.InternalNews && <NewsRegistrationInternal newsId={modalInfo.newsId} callerRefresh={() => { setNeedsRefreshPage(true) }} handleModalClose={() => setModalInfo({ ...modalInfo, isOpen: false })} />}
        {/* 2024.5.8 MyMine Version1.5対応 Add End */}
      </MyMModal>
    </Container >
  );
}
export default NewsManagement;
